import { registerStoreModule } from '@/web/store'
import session from '@/web/store/modules/session'
import SESSION from '@/web/store/types/session'

registerStoreModule('session', session)

export default SESSION
